<template>
    <div class="row" v-if="isSet">
        <div class="col-md-12 text-center">
            <div class="special-card w-100 border-0" style="width: 18rem;">
                <div class="card-body">
                    <p class="city-name">
                        <span v-if="city.is_coastal" class="coastal-badge" title="Coastal city">C</span>{{ city.name }}
                        <a @click="toggleLocator" class="btn btn-link btn-sm" style="font-size:12px; margin-left: 0; padding-left: 0; margin-top:12px;">
                            <span>{{ isLocatorEnabled ? 'close' : 'change' }} <font-awesome-icon :icon="isLocatorEnabled ? ['fas','times'] : ['fas','search-location']" /></span>
                        </a>
                        <a @click="$emit('toggle-wiki')" class="btn btn-link btn-sm" style="font-size:12px; padding-left:4px; margin-top:12px;">
                            <span>{{ showWiki ? 'close info' : 'info' }} <font-awesome-icon :icon="showWiki ? ['fas','times'] : ['fas','info-circle']" /></span>
                        </a>
                        <a @click="shareCity" class="btn btn-link btn-sm" style="font-size:12px; padding-left:4px; margin-top:12px;">
                            <span v-if="shareCopied">copied! <font-awesome-icon :icon="['fas', 'check']" /></span>
                            <span v-else>share <font-awesome-icon :icon="['fas', 'link']" /></span>
                        </a>
                    </p>
                    <h5><span v-if="city.region_name">{{ city.region_name }} </span><span v-if="city.country_iso" class="fi" :class="'fi-' + city.country_iso.toLowerCase()"></span> {{ city.country_name }}</h5>
                    <p>{{ city.formatted_latitude }} - {{ city.formatted_longitude }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'CityHeader',
    props: {
        showWiki: { type: Boolean, default: false },
    },
    data() {
        return {
            shareCopied: false,
        }
    },
    computed: {
        ...mapState(['city', 'isLocatorEnabled']),
        isSet() {
            return !!this.city && !!this.city.name
        },
    },
    methods: {
        ...mapMutations(['toggleLocator']),
        shareCity() {
            const url = `${window.location.origin}/city/${this.city.slug}`
            const done = () => {
                this.shareCopied = true
                setTimeout(() => { this.shareCopied = false }, 2000)
            }
            if (navigator.share) {
                navigator.share({ url, title: this.city.name }).catch(() => {})
            } else if (navigator.clipboard) {
                navigator.clipboard.writeText(url).then(done)
            } else {
                const el = document.createElement('textarea')
                el.value = url
                el.style.position = 'fixed'
                el.style.opacity = '0'
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                done()
            }
        },
    },
}
</script>

<style scoped>
.city-name {
    font-size: 2rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
}
.coastal-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.1rem;
    height: 1.1rem;
    font-size: 0.35em;
    font-weight: 700;
    color: #fff;
    background-color: navy;
    border-radius: 50%;
    vertical-align: super;
    margin-right: 4px;
    line-height: 0;
}
</style>
